import styled from "styled-components";
import { Button, Grid } from "@material-ui/core";

export const STFieldWrapper = styled.div`
   {
    max-width: 250px;
    padding-bottom: 1rem;
  }
`;

export const STButton = styled(Button)`
  && {
    margin-top: 25px;
  }
`;

export const STGrid = styled(Grid)`
  && {
    padding: 0 !important;
  }
`;
